/*@flow*/
import assert from './assert';
import isString from './isString';
import isFunction from './isFunction';
import forbidNewOperator from './forbidNewOperator';
import type { TypeT } from './types';
import withOptions from './withOptions';

type Predicate = (any) => boolean;
type IrreducibleType = TypeT<{ type: TypeT<*>, predicate: Predicate }>;

export default function irreducible(
  name: string,
  predicate: Predicate
): IrreducibleType {
  if (process.env.NODE_ENV !== 'production') {
    assert(isString(name), function() {
      return (
        'Invalid argument name ' +
        assert.stringify(name) +
        ' supplied to irreducible(name, predicate) (expected a string)'
      );
    });
    assert(
      isFunction(predicate),
      'Invalid argument predicate ' +
        assert.stringify(predicate) +
        ' supplied to irreducible(name, predicate) (expected a function)'
    );
  }

  function Irreducible(value: any, path?: string[]) {
    let path1 = path || [name];
    if (process.env.NODE_ENV !== 'production') {
      forbidNewOperator(this, Irreducible);
      assert(predicate(value), function() {
        return (
          'Invalid value ' +
          assert.stringify(value) +
          ' supplied to ' +
          path1.join('/')
        );
      });
    }

    return value;
  }

  Irreducible.meta = {
    kind: 'irreducible',
    name,
    predicate,
    identity: true,
  };

  Irreducible.displayName = name;

  Irreducible.is = predicate;

  withOptions(Irreducible);

  return Irreducible;
}
